<template>
    <div class="container-page py-10 md:py-14">
        <SectionHeading title="Professional Tech Expertise">
            Continuously advancing in various computer science fields, I embrace new challenges and consistently
            enhance my skills, staying at the forefront of technological innovation.
        </SectionHeading>

        <div class="grid gap-5 md:grid-cols-3">
            <article v-for="area in areas" :key="area.title" class="card flex flex-col p-7">
                <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-accent-soft text-accent">
                    <i :class="area.icon" aria-hidden="true"></i>
                </div>
                <h3 class="mt-6 font-display text-[19px] font-semibold leading-snug text-ink">{{ area.title }}</h3>
                <p class="mt-3 text-[15px] leading-[1.75] text-ink-2">{{ area.text }}</p>
            </article>
        </div>
    </div>
</template>

<script>
import SectionHeading from '@/components/ui/SectionHeading.vue'

export default {
    components: { SectionHeading },
    data() {
        return {
            areas: [
                {
                    title: 'Backend Development',
                    icon: 'fa-solid fa-server',
                    text: 'Backend development is my primary focus. I build production APIs and cloud-native microservices with Python, FastAPI, TypeScript, Node.js, and Express. My work spans PostgreSQL, MongoDB, Redis, Apache Kafka, NATS JetStream, MQTT, and WebSockets, with containerized deployments on AWS using Docker, Kubernetes, Helm, Terraform, and GitHub Actions. I also develop automated tests with pytest, add observability with Prometheus, Grafana, OpenTelemetry, and Jaeger, and build AI-powered backend features using LangChain and OpenAI tool-calling.'
                },
                {
                    title: 'Vehicle Telemetry & Connected Systems',
                    icon: 'fa-solid fa-satellite-dish',
                    text: 'My experience is on the software side of connected vehicle systems rather than firmware development. I build pipelines that ingest, decode, store, and stream GPS, IO, and CAN/J1939 telemetry, process vehicle data in real time, and deliver diagnostics through Vue.js and Flutter applications. I use PostgreSQL, Redis, NATS JetStream, MQTT, and WebSockets to support reliable fleet monitoring, historical analysis, and real-time alerts.'
                },
                {
                    title: 'Mobile App Development',
                    icon: 'fa-solid fa-mobile-screen-button',
                    text: 'I build cross-platform mobile applications with Flutter for iOS and Android, including production tools for real-time vehicle monitoring and customer-facing applications. My work includes state management with Riverpod and Provider, REST API and WebSocket integration, Firebase Authentication and push notifications, and Bluetooth Low Energy integrations. I focus on reliable backend connectivity, maintainable application architecture, and clear interfaces for presenting live data.'
                }
            ]
        };
    }
};
</script>
